const API_BASE = process.env.VUE_APP_BASE_API || ''

function getToken() {
  return localStorage.getItem('accessToken') || localStorage.getItem('token') || ''
}

function buildQuery(params = {}) {
  const query = Object.keys(params)
    .filter(key => params[key] !== undefined && params[key] !== null && params[key] !== '')
    .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
    .join('&')
  return query ? `?${query}` : ''
}

async function request(url, method = 'GET', data = null) {
  const headers = {
    'accessToken': getToken()
  }
  let body
  if (method === 'POST') {
    headers['Content-Type'] = 'application/x-www-form-urlencoded'
    const sp = new URLSearchParams()
    Object.keys(data || {}).forEach(key => {
      if (data[key] !== undefined && data[key] !== null) {
        sp.append(key, data[key])
      }
    })
    body = sp.toString()
  }
  const resp = await fetch(`${API_BASE}${url}`, { method, headers, body })
  const text = await resp.text()
  if (!text) {
    return { code: 201, msg: `接口返回空内容：${url}`, data: [] }
  }
  try {
    return JSON.parse(text)
  } catch (e) {
    return {
      code: 201,
      msg: `接口返回非JSON：${url}`,
      data: { raw: text.slice(0, 500), error: e.message }
    }
  }
}

export function merchantList(params) {
  return request(`/api/price-monitor/merchant/list${buildQuery(params)}`)
}

export function authLogin(data) {
  return request('/api/price-monitor/auth/login', 'POST', data)
}

export function authLogout() {
  return request('/api/price-monitor/auth/logout', 'POST', {})
}

export function authChangePassword(data) {
  return request('/api/price-monitor/auth/change-password', 'POST', data)
}

export function merchantSave(data) {
  return request('/api/price-monitor/merchant/save', 'POST', data)
}

export function merchantStatus(data) {
  return request('/api/price-monitor/merchant/status', 'POST', data)
}

export function quoteList(params) {
  return request(`/api/price-monitor/quote/list${buildQuery(params)}`)
}

export function quoteSave(data) {
  return request('/api/price-monitor/quote/save', 'POST', data)
}

export function quoteDelete(data) {
  return request('/api/price-monitor/quote/delete', 'POST', data)
}

export function dictBrands(params) {
  return request(`/api/price-monitor/dict/brands${buildQuery(params)}`)
}

export function dictModels(params) {
  return request(`/api/price-monitor/dict/models${buildQuery(params)}`)
}

export function dictCapacities(params) {
  return request(`/api/price-monitor/dict/capacities${buildQuery(params)}`)
}

export function dictTenors(params) {
  return request(`/api/price-monitor/dict/tenors${buildQuery(params)}`)
}

export function ownQuoteSave(data) {
  return request('/api/price-monitor/own-quote/save', 'POST', data)
}

export function ownQuoteList(params) {
  return request(`/api/price-monitor/own-quote/list${buildQuery(params)}`)
}

export function ownQuoteDelete(data) {
  return request('/api/price-monitor/own-quote/delete', 'POST', data)
}

export function statsLowest(params) {
  return request(`/api/price-monitor/stats/lowest${buildQuery(params)}`)
}

export function compareList(params) {
  return request(`/api/price-monitor/compare/list${buildQuery(params)}`)
}

export function logList(params) {
  return request(`/api/price-monitor/log/list${buildQuery(params)}`)
}
